import * as React from 'react';
import {
    ShowButton,
    List,
    Datagrid,
    TextField,
    EditButton,
    TextInput,
    Filter,
    ReferenceField,
    ReferenceInput,
    SelectInput,
} from 'react-admin';

const ResourceFilter = props => (
    <Filter {...props}>
        <TextInput label="Search" source="q" />
        <ReferenceInput
            label="Instances"
            source="instance_id"
            reference="instances"
            allowEmpty
        >
            <SelectInput optionText="name" />
        </ReferenceInput>
    </Filter>
);

const ResourceList = props => (
    <List {...props} filters={<ResourceFilter />}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="name" />
            <ReferenceField label="Environment" source="environment_id" reference="environments">
                <TextField source="name" />
            </ReferenceField>
            <TextField source="type" />
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

export default ResourceList;